<span class="json-display-container">
  <h2 mat-dialog-title>
    {{
      data.logDeviceInfo
        ? viewModalConstants.ACTIVITY_TITLE
        : viewModalConstants.USER_TITLE
    }}
  </h2>
  <button mat-icon-button mat-dialog-close class="close-button">
    <mat-icon>close</mat-icon>
  </button>
  @if(!data.logDeviceInfo){
  <mat-dialog-content>
    <div class="user-info-form">
      <h3>User Information</h3>

      <mat-form-field appearance="outline">
        <mat-label>{{readableDisplayEnum.userId}}</mat-label>
        <input matInput readonly [value]="data.userId" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{readableDisplayEnum.userName}}</mat-label>
        <input matInput readonly [value]="data.userName" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{readableDisplayEnum.userFirstName}}</mat-label>
        <input matInput readonly [value]="data.userFirstName" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{readableDisplayEnum.userMiddleName}}</mat-label>
        <input matInput readonly [value]="data.userMiddleName" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{readableDisplayEnum.userLastName}}</mat-label>
        <input matInput readonly [value]="data.userLastName" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{readableDisplayEnum.userEmailId}}</mat-label>
        <input matInput readonly [value]="data.userEmailId" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{readableDisplayEnum.userOrganizationName}}</mat-label>
        <input matInput readonly [value]="data.userOrganizationName" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{readableDisplayEnum.userAssignedRole}}</mat-label>
        <input matInput readonly [value]="data.userAssignedRole" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{readableDisplayEnum.userAssignedSystem}}</mat-label>
        <input matInput readonly [value]="data.userAssignedSystem" />
      </mat-form-field>
      @if(data.userAssignedRole !== userAssignedRoleEnum.BIOMED){

      <h3>{{readableDisplayEnum.userLocationinfo}}</h3>
      <div class="location-info">
        @for(location of data.userLocationinfo; track location){
        @if(data.userAssignedRole === userAssignedRoleEnum.FSE){
        <h4>Region: {{ location.region }}</h4>
        }
        <mat-list>
          @if( location.countries[0] === "ALL"){
          <mat-list-item>All Countries</mat-list-item>
          }@else { @for (country of location.countries; track $index) {
          <mat-list-item>{{ country }}</mat-list-item>
          } }
        </mat-list>
        }
      </div>
      }

      <h3>Product Information</h3>
      @if(data.userAssignedRole === userAssignedRoleEnum.BIOMED){
      <div class="biomed-product-types">
        @for(product of data.userProductInjectorIDs; track $index){
        <div class="product-row">
          <h4>{{ this.productTypeObject?.[product.injectorType] ??  product.injectorType}}:</h4>

          <mat-form-field appearance="outline">
            <mat-label>{{readableDisplayEnum.userProductInjectorIDs}}</mat-label>

            <input
              matInput
              readonly
              [value]="product.injectorID"
              placeholder="Injector ID"
            />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{readableDisplayEnum.userLicenseExpirationDateTime}}</mat-label>

            <input
              matInput
              readonly
              [value]="
                product.userLicenseExpirationDateTime | pipeCustomDateFormat
              "
              placeholder="Expiration"
            />
          </mat-form-field>
        </div>
        }
      </div>
      }@else {
      <div class="product-types">
        <mat-form-field appearance="outline">
          <mat-label>{{readableDisplayEnum.userProductTypes}}</mat-label>
          <input matInput readonly [value]="this.userProductTypeArray" />
        </mat-form-field>
      </div>
      }

      <mat-form-field appearance="outline">
        <mat-label>{{readableDisplayEnum.userTokenExpiryTime}}</mat-label>
        <input matInput readonly [value]="data.userTokenExpiryTime" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{readableDisplayEnum.userCreatedDateTime}}</mat-label>
        <input
          matInput
          readonly
          [value]="data.userCreatedDateTime | pipeCustomDateFormat"
        />
      </mat-form-field>

      <mat-checkbox disabled [checked]="data.userIsActive">Active</mat-checkbox>

      <!-- <mat-checkbox disabled [checked]="data.userIsDevToolsAccess"
        >Dev Tools Access</mat-checkbox
      > -->
    </div>
  </mat-dialog-content>
  }@else {

  <mat-dialog-content>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>{{readableDisplayEnum.logEventDateTime}}</mat-label>
        <input
          matInput
          readonly
          [value]="data.logEventDateTime | pipeCustomDateFormat"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{readableDisplayEnum.logEventType}}</mat-label>
        <input matInput readonly [value]="data.logEventType" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{readableDisplayEnum.logSrcSystem}}</mat-label>
        <input matInput readonly [value]="data.logSrcSystem" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{readableDisplayEnum.logUserName}}</mat-label>
        <input matInput readonly [value]="data.logUserName" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{readableDisplayEnum.logDeviceInfo}}</mat-label>
        <input matInput readonly [value]="data.logDeviceInfo" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{readableDisplayEnum.logMessage}}</mat-label>
        <textarea matInput readonly>{{ data.logMessage }}</textarea>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  }
</span>
